import React from 'react';
import { C, FONT } from '../../constants/design-tokens';
import { useResponsiveSizes } from '../../../../hooks/use-responsive-sizes';

interface StudioLayoutProps {
  topbar: React.ReactNode;
  left: React.ReactNode;
  leftWidth?: number;
  center: React.ReactNode;
  right: React.ReactNode;
}

export const StudioLayout: React.FC<StudioLayoutProps> = ({ topbar, left, leftWidth = 280, center, right }) => {
  const { spacing } = useResponsiveSizes();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', background: C.appBg, fontFamily: FONT }}>
      {topbar}
      <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <aside
          style={{
            width: leftWidth,
            flexShrink: 0,
            background: C.bg,
            borderRight: `1px solid ${C.border}`,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            transition: 'width 0.25s ease'
          }}
        >
          {left}
        </aside>

        <main style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden', padding: spacing.lg }}>
          {center}
        </main>

        <aside
          style={{
            width: 320,
            flexShrink: 0,
            background: C.bg,
            borderLeft: `1px solid ${C.border}`,
            overflowY: 'auto',
            padding: spacing.md
          }}
        >
          {right}
        </aside>
      </div>
    </div>
  );
};
